import MenuProduct from "./menu_product";

class MenuCategory {
  constructor({ id, name, products }) {
    this.id = id;
    this.name = name;
    this.products = products;
  }

  toMap() {
    return {
      id: this.id,
      name: this.name,
      products: this.products
        ? this.products.map(product => product.toMap())
        : []
    };
  }

  static fromMap(snapData) {
    snapData.products = snapData.products
      ? snapData.products.map(product => MenuProduct.fromMap(product))
      : [];
    return new MenuCategory(snapData);
  }
}

export default MenuCategory;
